import { formatHumanDate } from '@/lib/date-display.js';
import OpenDeal from './OpenDeal.jsx';
import { Row } from './TermBlock.jsx';
import { PENDING_KIND_WORDS, SESSION_STATUS_WORDS, PENDING_PILOT_WORDS, PENDING_NOTE, NO_PILOT_FORMS, NOT_RECORDED, word } from './words.js';

// A PENDING TERM (services/v3/pending-terms.js): a deal that so far exists as
// a session only, because Start Renewal writes the policies row only once
// v3.write_store.policies flips. Read-only: the date it started, the session's
// own status word, the pilot invite state per form, and the way into the
// classic deal. Nothing here is editable and nothing here writes.
export default function PendingTerm({ p, account }) {
  const started = p.started_on ? formatHumanDate(p.started_on) : null;
  return (
    <article className="rounded-card border border-dashed border-border-strong bg-surface" data-term={p.id} data-pending-term data-kind={p.kind}>
      <header className="flex flex-wrap items-baseline gap-x-3 gap-y-1 border-b border-border px-4 py-2.5">
        <span className="text-[15px] font-semibold text-text" data-pending-heading>{word(PENDING_KIND_WORDS, p.kind)} {started || <span className="text-text-dim" data-state-word>{NOT_RECORDED}</span>}</span>
        <span className="rounded-pill border border-border px-2 py-0.5 text-[11px] text-text-muted" data-session-status={p.status}>{word(SESSION_STATUS_WORDS, p.status)}</span>
        {p.name ? <span className="font-mono text-sm text-text-muted">{p.name}</span> : null}
        <span className="ml-auto"><OpenDeal account={account} crmDealId={p.crm_deal_id} /></span>
      </header>
      <div className="px-4">
        {p.renews ? <Row label="Renews">the term ending <span className="font-mono">{formatHumanDate(p.renews.expiration_date)}</span></Row> : null}
        <Row label="Pilots">
          {p.pilots.length ? (
            <span className="flex flex-col gap-0.5" data-pending-pilots>
              {p.pilots.map((pp) => (
                <span key={pp.phf_id} data-pending-pilot={pp.state}>
                  <span className="font-medium">{pp.name || NOT_RECORDED}</span>
                  <span className="ml-2 text-xs text-text-muted">{word(PENDING_PILOT_WORDS, pp.state)}{pp.state === 'attested' && pp.attested_method ? ` (${pp.attested_method})` : ''}</span>
                  {pp.invited_at ? <span className="ml-2 text-xs text-text-dim">invite sent {formatHumanDate(pp.invited_at)}</span> : null}
                </span>
              ))}
            </span>
          ) : <span className="text-text-dim" data-state-word>{NO_PILOT_FORMS}</span>}
        </Row>
        <p className="py-2 text-[11px] italic text-text-dim" data-pending-note>{PENDING_NOTE}</p>
      </div>
    </article>
  );
}
